module.exports = __webpack_public_path__ + "static/media/15_l_maf_0_10.65.7bfec0bf.png";